export enum ContractStatus {
  IN_ANALYSIS = 'in_analysis',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export const convertContractStatus = (docStatus: ContractStatus): string => {
  let word: string;
  switch (docStatus) {
    case ContractStatus.IN_ANALYSIS:
      word = 'em análise';
      break;
    case ContractStatus.APPROVED:
      word = 'aprovado';
      break;
    case ContractStatus.REJECTED:
      word = 'rejeitado';
      break;
    default:
      word = '';
  }
  return word;
};
